import T from '../i18n/content.js';
import { useT } from '../i18n/LangContext.jsx';

export default function QuoteBand() {
  const t = useT();
  const Q = T.quote;

  return (
    <section className="quote-band">
      <div className="quote-band__inner">
        <span className="label">{t(Q.label)}</span>
        <blockquote>{t(Q.text)}</blockquote>
      </div>
    </section>
  );
}
